import React from 'react';
import { Chip } from '@mui/material';
import { BillStatus } from '@/types';
import { useI18n } from '@/hooks/useI18n';

interface BillStatusChipProps {
  status: BillStatus;
  size?: 'small' | 'medium';
}

const BillStatusChip: React.FC<BillStatusChipProps> = ({ status, size = 'small' }) => {
  const { t } = useI18n();

  const getBillStatusColor = (status: BillStatus) => {
    switch (status) {
      case BillStatus.DRAFT: return { bgcolor: 'grey.100', color: 'grey.800' };
      case BillStatus.GENERATED: return { bgcolor: 'info.50', color: 'info.800' };
      case BillStatus.SENT: return { bgcolor: 'warning.50', color: 'warning.800' };
      case BillStatus.PARTIALLY_PAID: return { bgcolor: 'orange.50', color: 'orange.800' };
      case BillStatus.FULLY_PAID: return { bgcolor: 'success.50', color: 'success.800' };
      default: return { bgcolor: 'grey.100', color: 'grey.800' };
    }
  };

  const getBillStatusLabel = (status: BillStatus) => {
    switch (status) {
      case BillStatus.DRAFT: return t('bill.status.draft');
      case BillStatus.GENERATED: return t('bill.status.generated');
      case BillStatus.SENT: return t('bill.status.sent');
      case BillStatus.PARTIALLY_PAID: return t('bill.status.partiallyPaid');
      case BillStatus.FULLY_PAID: return t('bill.status.fullyPaid');
      default: return status;
    }
  };

  const colorStyle = getBillStatusColor(status);

  return (
    <Chip
      label={getBillStatusLabel(status)}
      size={size}
      sx={{
        ...colorStyle,
        fontWeight: 500,
      }}
    />
  );
};

export default BillStatusChip;